// extracted by mini-css-extract-plugin
module.exports = {"textbox":"TextBox_textbox__1P3WN","form-legend":"TextBox_form-legend__1e7Fk","form-label":"TextBox_form-label__1Hmw9","required":"TextBox_required__Qe11p"};